export * from './dlg-get-access.component';